{
  "header": {
    "id": "ID",
    "firstname": "Prénom",
    "lastname": "Nom",
    "profile": "Profil",
    "profiles": "Profils",
    "email": "Email",
    "description": "Description",
    "sector": "Secteur",
    "sectors": "Secteurs",
    "group": "Groupe",
    "groups": "Groupes",
    "user": "Utilisateur",
    "users": "Utilisateurs",
    "application": "Applicatif",
    "applications": "Applicatifs",
    "equipment": "Équipement",
    "equipments": "Équipements",
    "label": "Nom",
    "nbUsers": "Nombre d'utilisateurs",
    "userGroup": "Groupe",
    "userGroups": "Groupes",
    "device": "Équipement",
    "devices": "Équipements"
  }
}
